import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Button } from 'primereact/button';
import { useQuery } from 'react-query';
import { getProposalById } from 'apis/proposals.api';
import { getAll as getAllResearchFields } from 'apis/researchFields.api';
import Loading from 'components/Loading';
import ProposalForm from '../../components/Form';

export default function ViewProposalPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { proposalId } = useParams();
  const {
    reset,
    control,
    formState: { errors },
    setValue,
  } = useForm();

  const { data: proposalDetailData, isLoading } = useQuery(
    ['proposalDetail', proposalId],
    () => getProposalById(proposalId),
    {
      enabled: !!proposalId,
    }
  );

  const { data: researchFieldsData } = useQuery(
    ['projectProposalResearchFields'],
    getAllResearchFields
  );

  const researchFields = useMemo(
    () =>
      researchFieldsData?.data?.map((e) => ({
        id: e.id,
        name: e.code ? t(`researchFields.${e.code}`) : e.name,
        code: e.code,
      })) ?? [],
    [researchFieldsData, t]
  );

  useEffect(() => {
    if (proposalDetailData?.data) {
      const data = proposalDetailData?.data?.data;

      reset({
        vietnameseName: data?.vietnameseName,
        yearProposed: data?.yearProposed,
        target: data?.target,
        type: data?.type,
        projectType: data?.projectType,
        fullname: data?.owner?.fullname,
        researchFieldIds: data?.proposalResearchFields?.map(
          ({ researchField, researchFieldId }) => researchField?.id ?? researchFieldId
        ),
        file: data?.attachmentFileUrl,
      });
    }
  }, [proposalDetailData, setValue]);

  return (
    <>
      {isLoading && <Loading />}

      <div className="bg-white p-6">
        <form>
          <ProposalForm
            disabled
            researchFields={researchFields}
            control={control}
            errors={errors}
            proposalDetailData={proposalDetailData?.data?.data}
          />
          <div
            className="text-right mt-4"
            style={{ display: 'flex', justifyContent: 'flex-end', gap: '14px' }}
          >
            <Button
              label={t('proposal.create.cancel')}
              className="w-7rem"
              severity="danger"
              onClick={() => navigate('/proposals')}
            />
          </div>
        </form>
      </div>
    </>
  );
}
